var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShapeDesktop1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 259 196",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M235.828 150.194C166.742 249.26 66.3116 164.841 24.7321 110.247C2.0232 83.1172 -25.1635 24.263 47.7608 5.88775C138.916 -17.0814 322.186 26.3602 235.828 150.194Z",
  fill: "current"
})));
export default SvgShapeDesktop1;